import { useQuery } from '@tanstack/react-query';
import type { BrandsPickerResponse } from '@zealot/shared/apiClient';
import { brandsPickerMany } from '@zealot/shared/apiClient';
import { useApiClient } from '@/contexts/ApiClientContext';

const EMPTY_BRANDS: BrandsPickerResponse[] = [];

export const useBrandPicker = () => {
  const client = useApiClient();

  return useQuery({
    queryKey: ['brandPicker'],
    queryFn: async () => {
      const response = await brandsPickerMany({ client });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to fetch brands');
      }

      return response.data?.data ?? EMPTY_BRANDS;
    },
  });
};
